export default __webpack_public_path__ + "static/media/userFive.fb7f0510.svg";